import { Factory } from "@g.frame/core";
import UIManager from "./UIManager";
export class UIManagerFactory extends Factory {
    constructor() {
        super();
        this.__constructor = UIManager;
        this.components = [];
    }
    setModules(loader, actionController, factory) {
        this.loader = loader;
        this.actionController = actionController;
        this.factory = factory;
    }
    get() {
        const component = new UIManager();
        component.setModules(this.loader, this.actionController, this.factory);
        component.on('dispose', (event) => this.onDispose(component, event.data.disposedObject));
        this.components.push(component);
        return component;
    }
    onDispose(component, disposedObject) {
        if (disposedObject === component)
            this.components.splice(this.components.indexOf(component), 1);
    }
    update(params) {
    }
}
